import { render, staticRenderFns } from "./old_report_whole.vue?vue&type=template&id=4564593e&scoped=true&"
import script from "./old_report_whole.vue?vue&type=script&lang=js&"
export * from "./old_report_whole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564593e",
  null
  
)

export default component.exports